<template>
  <span flex items-center space-x-1>
    <LogoSvg h-8 w-8 />

    <span class="dark:drop-shadow-[0_0_0.1mm_rgb(var(--c-primary)) hidden text-base font-bold drop-shadow-lg sm:block">
      Una <span class="text-lg text-primary-active">UI</span>
    </span>
  </span>
</template>
